import {
  Col,
  Descriptions,
  Form,
  Input,
  Row,
  InputNumber,
  Radio,
  Select,
} from 'antd'
import UploadFile from '@/components/UploadFile'
import ReadOnlyFormItem from '@/components/ReadOnlyFormItem'
import { deliveryPeriodEnum } from '@/global/enum/inquiry'
import { shifouNumEnum } from '@/global/enum'
import ProductCodePicker from '@/components/ProductCodePicker'
import UnitSelect from '@/components/UnitSelect'
import { BrandSelect } from '@/components/BrandSelect'
import { QuotationItemDTO } from '@/api/inquiry'
import { InquiryQuotationListItem } from '../../reducer'
import BrandSelect2 from '@/components/BrandSelect2'
import { supplierInquiryStatusEnum } from '@/global/enum'
import Uploadfiles from '@/modules/goodsdetailmodules/uploadfiles'
import { AttachmentPreview } from '../AttachmentPreview'
import { XJ_UPLOAD_OPTION } from '@/global/config'

interface TabItemProps {
  item?: QuotationItemDTO
  index: number
  bjdItem: InquiryQuotationListItem
}
export default function TabItem(props: TabItemProps) {
  const { item, index, bjdItem } = props
  const form = Form.useFormInstance()

  const format = (val: any) =>
    val === undefined || val === null || val === '' ? '-' : val

  // 判断是否为只读模式
  const onlyShowContent = supplierInquiryStatusEnum.isValueInLabels(
    bjdItem.inquiryStatus,
    ['已报价', '采购方取消'],
  )

  // 处理单位选择变化
  interface UnitOption {
    value: string
    label?: string
    children?: string
    name?: string
  }

  const handleUnitChange = (
    value: string,
    option: UnitOption | UnitOption[],
  ) => {
    // 兼容 antd 单选/多选的 option 结构
    const opt = Array.isArray(option) ? option[0] : option
    // 写入单位名称到隐藏字段（后端需要 quoteUnit 为单位名称）
    const unitName = opt?.label ?? opt?.children ?? opt?.name ?? ''
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteUnit'],
      unitName,
    )
    // FormItem 已绑定 quoteUnitCode，Select 的值自动写入编码，无需额外设置
  }

  // 选择物料后，回填名称、品牌、规格型号
  const handleProductSelected = (record: any) => {
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductName'],
      record?.name ?? '',
    )
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductBrand'],
      record?.brandName ?? '',
    )
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductSpec'],
      record?.manuCode ?? '',
    )
  }

  return (
    <>
      <Descriptions
        bordered
        size="small"
        column={3}
        labelStyle={{
          backgroundColor: '#EAECFC',
        }}
      >
        <Descriptions.Item label="物资名称" span={1}>
          {format(item?.clientMaterialName)}
        </Descriptions.Item>
        <Descriptions.Item label="规格/型号" span={1}>
          {format(item?.clientMaterialSpec)}
        </Descriptions.Item>
        <Descriptions.Item label="物资描述" span={1}>
          {format(item?.clientMaterialDesc)}
        </Descriptions.Item>
        <Descriptions.Item label="品牌">
          {format(item?.clientMaterialBrand)}
        </Descriptions.Item>
        <Descriptions.Item label="单位">
          {format(item?.clientMaterialUnit)}
        </Descriptions.Item>
        <Descriptions.Item label="数量">
          {format(item?.clientMaterialQty)}
        </Descriptions.Item>
        <Descriptions.Item label="技术规范编码">
          {format(item?.techSpecCode)}
        </Descriptions.Item>
        <Descriptions.Item label="产品限价（单价）">
          {format(item?.priceLimit)}
        </Descriptions.Item>
        <Descriptions.Item label="客方备注" span={1}>
          {format(item?.clientRemark)}
        </Descriptions.Item>
        <Descriptions.Item label="交货地点" span={1}>
          {format(item?.deliveryAddress)}
        </Descriptions.Item>
        <Descriptions.Item label="报价要求" span={1}>
          {format(item?.quotationRequirement)}
        </Descriptions.Item>
      </Descriptions>

      {/* 可编辑表单区域 */}
      <Row gutter={24} className="mt-[20px]">
        <Col span={8}>
          <ReadOnlyFormItem
            label="单价"
            name={['quotationOrderItemParamList', index, 'unitPrice']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请输入单价' }]}
            help={'含13%增值税'}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0.01}
              max={999999999.99}
              precision={2}
              step={0.01}
              placeholder="请输入"
              //   placeholder="请输入单价，最多两位小数"
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="物料编码"
            name={['quotationOrderItemParamList', index, 'quoteProductCode']}
            readOnly={onlyShowContent}
          >
            <ProductCodePicker
              placeholder="请选择"
              shipperCode={bjdItem.groupCode}
              onlyPick
              onSelected={handleProductSelected}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="品牌"
            name={['quotationOrderItemParamList', index, 'quoteProductBrand']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择品牌' }]}
          >
            <BrandSelect2 placeholder="请选择品牌" />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="物料名称"
            name={['quotationOrderItemParamList', index, 'quoteProductName']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请输入物料名称' }]}
          >
            <Input placeholder="请输入" maxLength={100} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="规格"
            name={['quotationOrderItemParamList', index, 'quoteProductSpec']}
            readOnly={onlyShowContent}
          >
            <Input placeholder="请输入" maxLength={100} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="单位"
            name={[
              'quotationOrderItemParamList',
              index,
              onlyShowContent ? 'quoteUnit' : 'quoteUnitCode',
            ]}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择单位' }]}
          >
            <UnitSelect placeholder="请选择单位" onChange={handleUnitChange} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="货期"
            name={['quotationOrderItemParamList', index, 'deliveryPeriod']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择货期' }]}
          >
            <Select placeholder="请选择" options={deliveryPeriodEnum}></Select>
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="是否含运费"
            name={['quotationOrderItemParamList', index, 'includeFreight']}
            readOnly={onlyShowContent}
            initialValue={1}
            formatValue={(val) => shifouNumEnum.getLabelByValue(val)}
            rules={[{ required: true, message: '请选择是否含运费' }]}
          >
            <Radio.Group options={shifouNumEnum}></Radio.Group>
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          {/* 上传产品资料 */}
          {!onlyShowContent && (
            <ReadOnlyFormItem
              label="产品明细附件"
              name={['quotationOrderItemParamList', index, 'attachmentList']}
              readOnly={onlyShowContent}
              valuePropName="dataSource"
              trigger="onChange"
              initialValue={[]}
            >
              <Uploadfiles
                textBtn="选择文件"
                type="inquiry"
                {...XJ_UPLOAD_OPTION}
                uploadBtnSuffix={
                  <span className="text-[#999]">
                    支持常见的图片、文件、压缩包
                  </span>
                }
              />
            </ReadOnlyFormItem>
          )}
          {onlyShowContent && (
            <Form.Item
              label="上传附件"
              name={['quotationOrderItemParamList', index, 'attachment']}
              valuePropName="attachment"
              trigger="onChange"
              initialValue={[]}
            >
              <AttachmentPreview />
            </Form.Item>
          )}
        </Col>
        <Col span={24}>
          <ReadOnlyFormItem
            label="产品市场价"
            name={['quotationOrderItemParamList', index, 'marketPrice']}
          >
            <InputNumber
              placeholder="请输入"
              min={0}
              max={99999999.99}
              precision={2}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="配置明细"
            name={['quotationOrderItemParamList', index, 'configDetail']}
            readOnly={onlyShowContent}
          >
            <Input.TextArea
              placeholder="请输入配置明细"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="参数差异点"
            name={['quotationOrderItemParamList', index, 'paramDifference']}
          >
            <Input.TextArea
              placeholder="请输入参数差异点"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8} className="break-all">
          <ReadOnlyFormItem
            label="备注"
            name={['quotationOrderItemParamList', index, 'remark']}
            readOnly={onlyShowContent}
          >
            <Input.TextArea
              placeholder="请输入备注"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
      </Row>
      {!onlyShowContent && (
        <ReadOnlyFormItem
          label="单位名称"
          hidden={true}
          name={['quotationOrderItemParamList', index, 'quoteUnit']}
        >
          <Input></Input>
        </ReadOnlyFormItem>
      )}
    </>
  )
}
import {
  Col,
  Descriptions,
  Form,
  Input,
  Row,
  InputNumber,
  Radio,
  Select,
} from 'antd'
import UploadFile from '@/components/UploadFile'
import ReadOnlyFormItem from '@/components/ReadOnlyFormItem'
import { deliveryPeriodEnum } from '@/global/enum/inquiry'
import { shifouNumEnum } from '@/global/enum'
import ProductCodePicker from '@/components/ProductCodePicker'
import UnitSelect from '@/components/UnitSelect'
import { BrandSelect } from '@/components/BrandSelect'
import { QuotationItemDTO } from '@/api/inquiry'
import { InquiryQuotationListItem } from '../../reducer'
import BrandSelect2 from '@/components/BrandSelect2'
import { supplierInquiryStatusEnum } from '@/global/enum'
import Uploadfiles from '@/modules/goodsdetailmodules/uploadfiles'
import { AttachmentPreview } from '../AttachmentPreview'
import { XJ_UPLOAD_OPTION } from '@/global/config'

interface TabItemProps {
  item?: QuotationItemDTO
  index: number
  bjdItem: InquiryQuotationListItem
}
export default function TabItem(props: TabItemProps) {
  const { item, index, bjdItem } = props
  const form = Form.useFormInstance()

  const format = (val: any) =>
    val === undefined || val === null || val === '' ? '-' : val

  // 判断是否为只读模式
  const onlyShowContent = supplierInquiryStatusEnum.isValueInLabels(
    bjdItem.inquiryStatus,
    ['已报价', '采购方取消'],
  )

  // 处理单位选择变化
  interface UnitOption {
    value: string
    label?: string
    children?: string
    name?: string
  }

  const handleUnitChange = (
    value: string,
    option: UnitOption | UnitOption[],
  ) => {
    // 兼容 antd 单选/多选的 option 结构
    const opt = Array.isArray(option) ? option[0] : option
    // 写入单位名称到隐藏字段（后端需要 quoteUnit 为单位名称）
    const unitName = opt?.label ?? opt?.children ?? opt?.name ?? ''
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteUnit'],
      unitName,
    )
    // FormItem 已绑定 quoteUnitCode，Select 的值自动写入编码，无需额外设置
  }

  // 选择物料后，回填名称、品牌、规格型号
  const handleProductSelected = (record: any) => {
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductName'],
      record?.name ?? '',
    )
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductBrand'],
      record?.brandName ?? '',
    )
    form.setFieldValue(
      ['quotationOrderItemParamList', index, 'quoteProductSpec'],
      record?.manuCode ?? '',
    )
  }

  return (
    <>
      <Descriptions
        bordered
        size="small"
        column={3}
        labelStyle={{
          backgroundColor: '#EAECFC',
        }}
      >
        <Descriptions.Item label="物资名称" span={1}>
          {format(item?.clientMaterialName)}
        </Descriptions.Item>
        <Descriptions.Item label="规格/型号" span={1}>
          {format(item?.clientMaterialSpec)}
        </Descriptions.Item>
        <Descriptions.Item label="物资描述" span={1}>
          {format(item?.clientMaterialDesc)}
        </Descriptions.Item>
        <Descriptions.Item label="品牌">
          {format(item?.clientMaterialBrand)}
        </Descriptions.Item>
        <Descriptions.Item label="单位">
          {format(item?.clientMaterialUnit)}
        </Descriptions.Item>
        <Descriptions.Item label="数量">
          {format(item?.clientMaterialQty)}
        </Descriptions.Item>
        <Descriptions.Item label="技术规范编码">
          {format(item?.techSpecCode)}
        </Descriptions.Item>
        <Descriptions.Item label="产品限价（单价）">
          {format(item?.priceLimit)}
        </Descriptions.Item>
        <Descriptions.Item label="客方备注" span={1}>
          {format(item?.clientRemark)}
        </Descriptions.Item>
        <Descriptions.Item label="交货地点" span={1}>
          {format(item?.deliveryAddress)}
        </Descriptions.Item>
        <Descriptions.Item label="报价要求" span={1}>
          {format(item?.quotationRequirement)}
        </Descriptions.Item>
      </Descriptions>

      {/* 可编辑表单区域 */}
      <Row gutter={24} className="mt-[20px]">
        <Col span={8}>
          <ReadOnlyFormItem
            label="单价"
            name={['quotationOrderItemParamList', index, 'unitPrice']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请输入单价' }]}
            help={'含13%增值税'}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0.01}
              max={999999999.99}
              precision={2}
              step={0.01}
              placeholder="请输入"
              //   placeholder="请输入单价，最多两位小数"
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="物料编码"
            name={['quotationOrderItemParamList', index, 'quoteProductCode']}
            readOnly={onlyShowContent}
          >
            <ProductCodePicker
              placeholder="请选择"
              shipperCode={bjdItem.groupCode}
              onlyPick
              onSelected={handleProductSelected}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="品牌"
            name={['quotationOrderItemParamList', index, 'quoteProductBrand']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择品牌' }]}
          >
            <BrandSelect2 placeholder="请选择品牌" />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="物料名称"
            name={['quotationOrderItemParamList', index, 'quoteProductName']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请输入物料名称' }]}
          >
            <Input placeholder="请输入" maxLength={100} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="规格"
            name={['quotationOrderItemParamList', index, 'quoteProductSpec']}
            readOnly={onlyShowContent}
          >
            <Input placeholder="请输入" maxLength={100} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="单位"
            name={[
              'quotationOrderItemParamList',
              index,
              onlyShowContent ? 'quoteUnit' : 'quoteUnitCode',
            ]}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择单位' }]}
          >
            <UnitSelect placeholder="请选择单位" onChange={handleUnitChange} />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="货期"
            name={['quotationOrderItemParamList', index, 'deliveryPeriod']}
            readOnly={onlyShowContent}
            rules={[{ required: true, message: '请选择货期' }]}
          >
            <Select placeholder="请选择" options={deliveryPeriodEnum}></Select>
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="是否含运费"
            name={['quotationOrderItemParamList', index, 'includeFreight']}
            readOnly={onlyShowContent}
            initialValue={1}
            formatValue={(val) => shifouNumEnum.getLabelByValue(val)}
            rules={[{ required: true, message: '请选择是否含运费' }]}
          >
            <Radio.Group options={shifouNumEnum}></Radio.Group>
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          {/* 上传产品资料 */}
          {!onlyShowContent && (
            <ReadOnlyFormItem
              label="产品明细附件"
              name={['quotationOrderItemParamList', index, 'attachmentList']}
              readOnly={onlyShowContent}
              valuePropName="dataSource"
              trigger="onChange"
              initialValue={[]}
            >
              <Uploadfiles
                textBtn="选择文件"
                type="inquiry"
                {...XJ_UPLOAD_OPTION}
                uploadBtnSuffix={
                  <span className="text-[#999]">
                    支持常见的图片、文件、压缩包
                  </span>
                }
              />
            </ReadOnlyFormItem>
          )}
          {onlyShowContent && (
            <Form.Item
              label="上传附件"
              name={['quotationOrderItemParamList', index, 'attachment']}
              valuePropName="attachment"
              trigger="onChange"
              initialValue={[]}
            >
              <AttachmentPreview />
            </Form.Item>
          )}
        </Col>
        <Col span={24}>
          <ReadOnlyFormItem
            label="产品市场价"
            name={['quotationOrderItemParamList', index, 'marketPrice']}
          >
            <InputNumber
              placeholder="请输入"
              min={0}
              max={99999999.99}
              precision={2}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="配置明细"
            name={['quotationOrderItemParamList', index, 'configDetail']}
            readOnly={onlyShowContent}
          >
            <Input.TextArea
              placeholder="请输入配置明细"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8}>
          <ReadOnlyFormItem
            label="参数差异点"
            name={['quotationOrderItemParamList', index, 'paramDifference']}
          >
            <Input.TextArea
              placeholder="请输入参数差异点"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
        <Col span={8} className="break-all">
          <ReadOnlyFormItem
            label="备注"
            name={['quotationOrderItemParamList', index, 'remark']}
            readOnly={onlyShowContent}
          >
            <Input.TextArea
              placeholder="请输入备注"
              rows={5}
              showCount
              maxLength={250}
            />
          </ReadOnlyFormItem>
        </Col>
      </Row>
      {!onlyShowContent && (
        <ReadOnlyFormItem
          label="单位名称"
          hidden={true}
          name={['quotationOrderItemParamList', index, 'quoteUnit']}
        >
          <Input></Input>
        </ReadOnlyFormItem>
      )}
    </>
  )
}
